export const catalog = [
  {
    id: 'coco',
    name: 'Coco',
    color: '#3fb956',
    accent: 'from-green-500/20 to-emerald-600/10',
    description: 'Sabor tropical e cremoso do coco fresco. Perfeito para dias quentes.',
    image: 'https://customer-assets-4nw71qhi.emergentagent.net/job_flavored-ice-factory/artifacts/3kpfy7e6_imperio-ice-coco-200g-removebg-preview-2.png',
  },
  {
    id: 'maca-verde',
    name: 'Maçã Verde',
    color: '#65a30d',
    accent: 'from-green-400/20 to-lime-600/10',
    description: 'Doce e refrescante, com o sabor autêntico da maçã verde.',
    image: 'https://customer-assets-4nw71qhi.emergentagent.net/job_flavored-ice-factory/artifacts/47elqx38_imperio-ice-maca-verde-200g-removebg-preview.png',
  },
  {
    id: 'maracuja',
    name: 'Maracujá',
    color: '#eab308',
    accent: 'from-yellow-500/20 to-amber-600/10',
    description: 'Sabor tropical levemente ácido do maracujá. Refrescante e marcante.',
    image: '/catalog/maracuja.png',
  },
  {
    id: 'melancia',
    name: 'Melancia',
    color: '#dc2626',
    accent: 'from-red-500/20 to-rose-600/10',
    description: 'O sabor doce e refrescante da melancia bem madura.',
    image: 'https://customer-assets-4nw71qhi.emergentagent.net/job_flavored-ice-factory/artifacts/7b0cwd9u_imperio-ice-melancia-vermelha-logo-branca-200g-removebg-preview.png',
  },
  {
    id: 'morango',
    name: 'Morango',
    color: '#e11d48',
    accent: 'from-rose-500/20 to-red-600/10',
    description: 'O sabor clássico e doce do morango bem vermelho.',
    image: '/catalog/morango.png',
  },
];
